export interface WalkthroughDocumentStepDto {
  id?: number;
  index: number;
  path: string;
  walkthroughDocumentRefId?: number;
  title: string;
  html?: string;
  href?: string;
  /**
   * What advances this step: the popover's Next button, or the user operating the
   * highlighted control itself ("tap the Save button"). When unset the platform
   * infers it from the control kind, which is the only behavior tours authored
   * before this field get — set it explicitly for anything an author cares about.
   *
   * Not yet persisted by the Software Security API; the column and C# DTO field
   * are pending, so a value set here does not survive a round trip.
   */
  advanceOn?: 'next' | 'tap';

  steps?: WalkthroughDocumentStepDto[];
}
